// @flow

import type { BaseAddress } from './base-address'
import type { ContactPersonDetails } from './contact-details'
import { buildVisitAddress } from './visit-address'
import { buildContactPersonDetails } from './contact-details'
import type { AddressType } from './address-type'
import { ADDRESS_TYPE_PRIMARY } from './address-type'

export type PrimaryAddress = BaseAddress & ContactPersonDetails & {
  isSameAsAddress: AddressType,
  postOfficeBox?: ?string,
  street?: string,
  houseNumber?: ?number,
  houseNumberExtension?: ?string,
}

const buildPrimaryAddress = (): PrimaryAddress => {
  return {
    isSameAsAddress: ADDRESS_TYPE_PRIMARY,
    postOfficeBox: null,
    ...buildVisitAddress(),
    ...buildContactPersonDetails()
  }
}

export {
  buildPrimaryAddress
}



// WEBPACK FOOTER //
// ./src/types/primary-address.js